<template>
  <div>
    <div v-for="company in agentSelectionAuctions" class="col-xs-4">
      <agent-selection-auction-id-checkbox
        :name="fieldName"
        :key="company.id"
        :item="company"
        :disabled="disabled(company.id)"
        :validator="validator"
        :dispatcher="dispatcher"
      />
    </div>
  </div>
</template>

<script setup>
import { useStore } from "vuex";
import {
  useAuctionCompaniesField,
  useAuctionCompaniesStore
} from "@component_path/inquiry_form_common_module/custom_hook/AuctionCompanies";

import AgentSelectionAuctionIdCheckbox from "@component_path/pages/pc/agent_selection/secret/components/form_element/AgentSelectionAuctionIdCheckbox";
import { computed } from "vue";

const store = useStore();

const props = defineProps({
  required: {
    type: Boolean,
    required: false,
    default: false
  },
  agentSelectionAuctions: {
    type: Array,
    required: true
  }
});

const { validator, fieldName } = useAuctionCompaniesField(props.required);
const { dispatcher, agentSelectionAuctionIds } = useAuctionCompaniesStore();

const maxSelectCount = computed(() => store.state.maxSelectCount);

const disabled = id =>
  agentSelectionAuctionIds.value.length >= maxSelectCount.value &&
  !agentSelectionAuctionIds.value.includes(id);
</script>
